import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { useTranslate } from "../../../language/i18n";
import pages from "../../../utils/pages";
import { exchangeToken } from "./services/openIdService";

export const OpenIdAuthenticationCallback = () => {
  const history = useHistory();
  const translate = useTranslate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const getToken = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");

      if (code === null) {
        setError(translate("AUTHENTICATION") + " " + translate("FAILED"));

        return;
      }

      const redirect_uri_path = process.env.REACT_APP_OPEN_ID_REDIRECT_URI_PATH;

      if (!redirect_uri_path) return;

      const redirect_uri = window.location.origin + redirect_uri_path;

      try {
        const { isOk, data } = await exchangeToken({ code, redirect_uri });

        if (!isOk || !data?.token) {
          history.push(pages.HOME);

          return;
        }

        window.location.href = `/?loginToken=${data.token}`;
      } catch (err) {
        setError(`${translate("AUTHENTICATION")} ${translate("FAILED")}`);
      }
    };

    getToken();
  }, [history, translate]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      {error ? (
        <>
          <h2>
            {translate("AUTHENTICATION")} {translate("FAILED")}
          </h2>
          <p>{error}</p>
        </>
      ) : (
        <h2>{translate("VALIDATING_AUTHENTICATION")}</h2>
      )}
    </div>
  );
};
